var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-alert",
            {
              attrs: {
                value: !_vm.isAuthenticated,
                type: "error",
                outline: "",
              },
            },
            [
              _vm._v(
                "\n      Unauthorized, the page is only visible to system administrators. If you think you have system administrator credentials, try refreshing your page or notify support at envirodata-techsupport(at)hatfieldgroup.com\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("StaticContentHomePageCard", {
            attrs: { "tenant-name": _vm.name },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }